import {
  setBuilderProduct,
  setDisableJewelrySettingStoneLinkage,
  setLoginModalType,
  setProductType,
} from "@redux/slices/appStateSlice";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { Linking, Platform, TouchableOpacity } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { SpaceType } from "@components/atoms/Spacer/types";
import {
  getBoxShadow,
  getButtonCategory,
  isPair,
  isParcel,
} from "@utils/product/productValidators";
import { ButtonType } from "@components/atoms/Button/types";
import { Button, VDBText } from "@components/atoms";
import styled from "styled-components/native";
import { Menu, MenuItem } from "@gluestack-ui/themed";
import LineViewContainer from "@scenes/requests/utils/LineView";
import { css } from "styled-components/native";
import TooltipButton from "./TooltipButton";
import { CartTypeRequest, getStockItemType } from "@scenes/searchResults/Utils";
import { showToast, ToastTypes } from "@components/molecules/VDBToast/util";
import { navigate, push } from "@navigations/utils/RootNavigation";
import {
  AddJewelryOptions,
  getProductPrefix,
  ProductCategory,
} from "@utils/constants";
import Routes from "@navigations/Routes";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";
import { useJewelryConfiguratorState } from "@scenes/configurator/JewelryConfigurator/Context/JewelryConfiguratorContext";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";
import { CommonActions, useNavigation } from "@react-navigation/native";
import {
  BreadCrumbLabel,
  NavigationHistoryState,
} from "@components/molecules/Breadcrumbs/utils";
import { PdpSections } from "@utils/customization";
import OptionsModal from "./OptionsModal";
import {
  getAddToJewelryOptionsDataOptions,
  getChooseStoneOptions,
} from "./utils";
import { StoneType } from "@scenes/bulk-request/Utils";
import {
  resetFiltersPayload,
  resetMinMaxOptions,
  setAuxPayloadData,
  setFiltersPayload,
  setPayloadData,
  setSectionName,
  useSearchFiltersAuxPayload,
} from "@redux/slices/searchFilters";
import { useGetMinMaxOptions } from "@apis/useGetMinMaxOptions";
import { useCallback, useRef, useState } from "react";
import {
  sendToParentCart,
  getMaxExternalCartQuantity,
} from "@utils/externalCart";
import { useCreateShopifyProduct } from "@apis/shopifyCart";
import {
  buildShopifyCreatePayload,
  buildShopifyCartProperties,
} from "@utils/shopifyCartIntegration";
import { CartItemsResult } from "@src/types/CartItemResult";
import { CheckItemAvailabilityResponse } from "@src/types/CartItemListResponse";
import { CartTypeEnum } from "@utils/product/searchResultConstants";
import { getSectionName } from "@utils/product/searchResultsNavigation";
import { toSettingSearchFirstFlowParams } from "@scenes/searchResults/utils/stripJewelryLinkageFromPayload";
import {
  useAllowQuantityOnBulk,
  useAllowBMHAndCartActions,
  useConsolidatedStoneTypes,
} from "@redux/slices/globalSlice";

const PdpBottomButtons = ({
  bottomButtons,
  route,
  product_type,
  disabledMemo,
  addToJewelryMenu,
  setAddToJewelryMenu,
  getAddToJewelryOptionsData,
  setModals,
  setSelectedTabSlideSheet,
  priceMode,
  checkAllFieldsEntered,
  addToCart,
  itemQuantity,
  enterSecondFlow: mEnterSecondFlow,
  fromReviewPage,
  enableJewelryBuilder,
  itemDetail,
  stoneItemDetail,
  fromRequest,
  fromOrderCart,
  matchingPairItemDetail,
  haveMatchPair,
  checkItemAvailability,
  stoneToSettingPopupDismissed,
}: any) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { addRouteToHistory, clearRouteHistory } = useNavigationHistory();
  const navigation = useNavigation();
  const allowQuantityOnBulk = useAllowQuantityOnBulk();
  const userInfo = useUserInfo();
  const isGuest = useSelector((state) => state.userInfo.isGuest);
  const { history } = useSelector(
    (state: any) => state.navigationHistory as NavigationHistoryState
  );
  const enterSecondFlow =
    typeof mEnterSecondFlow === "string"
      ? mEnterSecondFlow.trim().toLowerCase() === "true"
        ? true
        : mEnterSecondFlow.trim().toLowerCase() === "false"
        ? false
        : mEnterSecondFlow
      : mEnterSecondFlow;

  const { theme, t, typography } = useScreenOptionsHooks();
  const isCustomApp = useSelector((state: any) => state.appState?.isCustomApp);

  const {
    jcSelectedOption,
    personalization,
    hasPersonalizationError,
    validateRequiredOptions,
    setStoneItemDetail,
    setItemDetail,
    itemDetail: mItemDetail,
    stoneItemDetail: mStoneItemDetail,
    resetDefaultSlug,
    setMatchingPairItemDetail,
    clearItemDetail,
  } = useJewelryConfiguratorState();
  const jewelryStyle = enterSecondFlow
    ? mStoneItemDetail?.jewelry_style
    : mItemDetail?.jewelry_style;
  const isEarring = jewelryStyle?.includes("Earring");
  const isPendant = jewelryStyle?.includes("Pendant");
  const allowBMHAndCartActions = useAllowBMHAndCartActions();
  const consolidatedStoneType = useConsolidatedStoneTypes();
  const isJewelry = product_type === ProductCategory.JEWELRY;
  const isCustomizableJewelry =
    isJewelry && itemDetail?.is_customizable === "jewelry_builder";
  const [enabled, setEnabled] = useState(false);
  useGetMinMaxOptions(
    userInfo.user.feature_settings?.allow_search_modify_in_builder && enabled,
    itemDetail?.id,
    setEnabled
  );

  const mandatoryOptionsSelected = () => {
    const isValid =
      product_type === ProductCategory.JEWELRY ||
      product_type === ProductCategory.LABGROWN_JEWELRY
        ? !checkAllFieldsEntered(
            jcSelectedOption?.current?.option_value,
            jcSelectedOption?.current?.option_required
          ) && !hasPersonalizationError
        : true;

    return isValid;
  };
  let auxPayload = useSearchFiltersAuxPayload();

  const createShopifyProduct = useCreateShopifyProduct();
  const [isShopifyDelaying, setIsShopifyDelaying] = useState(false);

  const showSelectSettingError = () => {
    showToast(
      t("productDetailPage.selectSetting.error.title.text"),
      t("productDetailPage.selectSetting.error.subTitle.text"),
      ToastTypes.ERROR,
      true,
      true
    );
  };

  const showAddedToCartError = () => {
    showToast(
      undefined,
      t("productDetailPage.addedToCart.text"),
      ToastTypes.SUCCESS,
      true,
      true
    );
  };

  const showAddToJewelryError = (type?: "order" | "request" | "builder") => {
    if (type === "request") {
      showToast(
        t("productDetailPage.addToJewelry.request.error.title.text"),
        t("productDetailPage.addToJewelry.request.error.subTitle.text"),
        ToastTypes.ERROR,
        true,
        true
      );
    } else if (type === "builder") {
      showToast(
        t("productDetailPage.addToJewelry.builder.error.title.text"),
        t("productDetailPage.addToJewelry.builder.error.subTitle.text"),
        ToastTypes.ERROR,
        true,
        true
      );
    } else {
      showToast(
        t("productDetailPage.addToJewelry.order.error.title.text"),
        t("productDetailPage.addToJewelry.order.error.subTitle.text"),
        ToastTypes.ERROR,
        true,
        true
      );
    }
  };

  const navigateToReviewPage = () => {
    const params = {
      breadCrumbLabel: BreadCrumbLabel.REVIEW,
      enterSecondFlow: enterSecondFlow,
      priceMode: priceMode,
      productPrefix: ProductCategory.JEWELRY,
      productType: ProductCategory.JEWELRY,
    };
    const mRoute = { name: Routes.ReviewPage, params };
    dispatch(setBuilderProduct(ProductCategory.JEWELRY));
    addRouteToHistory(mRoute);
    push(Routes.ReviewPage, params);
  };

  const toggleModal = (modalName: string, isVisible: boolean) => {
    setModals((prevModals) => ({
      ...prevModals,
      [modalName]: isVisible,
    }));
  };

  let chooseStones = [
    {
      name: "Choose Natural Diamond",
      label: t(
        "productDetailPage.chooseStone.title.text",
        "Choose Natural Diamond"
      ),
      long_name: t(
        "productDetailPage.chooseStone.title.text",
        "Choose Natural Diamond"
      ),
      action_name: ProductCategory.DIAMOND,
      price_modes: [0, 1, 2],
    },
  ];
  if (Array.isArray(bottomButtons)) {
    bottomButtons.flat().forEach((element) => {
      if (element.name === "jewelry_builder_button") {
        if (element?.chooseStonesOptions) {
          chooseStones = element?.chooseStonesOptions;
        }
      }
    });
  }

  chooseStones = chooseStones?.filter(
    (stone) =>
      userInfo.getAllowedStockTypes().includes(stone.action_name) &&
      (!isEarring || stone.action_name !== "gemstone")
  );

  const handleOpen = (type?: string) => {
    validateRequiredOptions();
    if (
      (itemDetail.custom_design_configuration &&
        mandatoryOptionsSelected() &&
        !checkAllFieldsEntered(
          jcSelectedOption?.current?.option_value,
          jcSelectedOption?.current?.option_required
        )) ||
      !itemDetail.custom_design_configuration
    ) {
      setSelectedTabSlideSheet(type ?? "memo");
      userInfo.canRequest()
        ? toggleModal("showBMHModal", true)
        : toggleModal("bmhPopUp", true);
    } else {
      showToast(
        t("productDetailPage.addToCart.error.title.text"),
        t("productDetailPage.addToCart.error.subTitle.text"),
        ToastTypes.ERROR,
        true,
        true
      );
      return;
    }
  };

  const handleOpenAskSupplier = () => {
    toggleModal("showAskSupplierModal", true);
  };

  const handleAddToBulkRequest = () => {
    validateRequiredOptions();
    if (
      (itemDetail.custom_design_configuration &&
        mandatoryOptionsSelected() &&
        !checkAllFieldsEntered(
          jcSelectedOption?.current?.option_value,
          jcSelectedOption?.current?.option_required
        ) &&
        !hasPersonalizationError) ||
      !itemDetail.custom_design_configuration
    ) {
      if (userInfo?.restrictActionOnUnavailableItems()) {
        checkItemAvailabilityForBulk(
          CartTypeEnum.BULK_REQUEST_TYPE,
          product_type
        );
      } else {
        addToBulkRequest(CartTypeEnum.BULK_REQUEST_TYPE, product_type);
      }
    } else {
      showToast(
        t("productDetailPage.addToCart.error.title.text"),
        t("productDetailPage.addToCart.error.subTitle.text"),
        ToastTypes.ERROR,
        true,
        true
      );
      return;
    }
  };

  const handleSeeBuyRequest = () => {
    if (history.length > 0) {
      navigation.goBack();
    }
  };

  const handleAddToShopifyCart = () => {
    const quantity = itemQuantity || 1;
    const payload = buildShopifyCreatePayload(itemDetail);

    const properties = buildShopifyCartProperties({
      config: jcSelectedOption?.current?.option_value ?? {},
      personalization: personalization ?? {},
      displayConfiguration: itemDetail?.display_configuration_v2,
      slugDetail: itemDetail?.slug_detail,
    });

    setIsShopifyDelaying(true);
    createShopifyProduct.mutate(
      { payload, quantity, properties },
      {
        onSuccess(data) {
          setTimeout(() => {
            setIsShopifyDelaying(false);
            const firstVariantId = data?.data?.product?.[0]?.variants?.[0]?.id;
            if (firstVariantId) {
              showToast(
                "",
                t(
                  "productDetail.addToShopifyCart.success.text",
                  "Added to cart"
                ),
                ToastTypes.SUCCESS,
                true,
                true,
                80
              );
            } else {
              showToast(
                "",
                t(
                  "productDetail.addToShopifyCart.error.text",
                  "Failed to add to cart"
                ),
                ToastTypes.ERROR,
                true,
                true,
                80
              );
            }
          }, 1000);
        },
        onError() {
          setIsShopifyDelaying(false);
          showToast(
            "",
            t(
              "productDetail.addToShopifyCart.error.text",
              "Failed to add to cart"
            ),
            ToastTypes.ERROR,
            true,
            true,
            80
          );
        },
      }
    );
  };

  const handleAddToCart = () => {
    validateRequiredOptions();
    if (
      !itemDetail?.in_cart &&
      mandatoryOptionsSelected() &&
      !checkAllFieldsEntered(
        jcSelectedOption?.current?.option_value,
        jcSelectedOption?.current?.option_required
      ) &&
      !hasPersonalizationError
    ) {
      if (userInfo.hasShopifyCheckout()) {
        handleAddToShopifyCart();
        return;
      }
      const cartType = userInfo.enableShoppingCart()
        ? CartTypeEnum.SHOPPING_CART_TYPE
        : CartTypeEnum.ORDER_CART;
      if (userInfo?.restrictActionOnUnavailableItems()) {
        checkItemAvailabilityForBulk(cartType, product_type);
      } else {
        addToOrderCart(cartType, product_type);
      }
    } else {
      showToast(
        t("productDetailPage.addToCart.error.title.text"),
        t("productDetailPage.addToCart.error.subTitle.text"),
        ToastTypes.ERROR,
        true,
        true
      );
      return;
    }
  };

  const handleBuyNow = (isBuyNow: boolean = false) => {
    if (product_type === ProductCategory.JEWELRY) {
      validateRequiredOptions();
      if (
        !itemDetail?.in_cart &&
        !checkAllFieldsEntered(
          jcSelectedOption?.current?.option_value,
          jcSelectedOption?.current?.option_required
        ) &&
        !hasPersonalizationError
      ) {
        const cartType = userInfo.enableShoppingCart()
          ? CartTypeEnum.SHOPPING_CART_TYPE
          : CartTypeEnum.ORDER_CART;
        if (userInfo?.restrictActionOnUnavailableItems()) {
          checkItemAvailabilityForBulk(cartType, product_type, isBuyNow);
        } else {
          addToOrderCart(cartType, product_type, isBuyNow);
        }
      } else {
        showToast(
          t("productDetailPage.addToCart.error.title.text"),
          t("productDetailPage.addToCart.error.subTitle.text"),
          ToastTypes.ERROR,
          true,
          true
        );
        return;
      }
    } else {
      const cartType = userInfo.enableShoppingCart()
        ? CartTypeEnum.SHOPPING_CART_TYPE
        : CartTypeEnum.ORDER_CART;
      addToOrderCart(cartType, product_type, isBuyNow);
    }
  };

  /**
   * Handles "Add to Cart" for third-party / iFrame integrations.
   * Validates jewelry configuration, enforces quantity limits,
   * and sends the item data to the parent window via postMessage.
   */
  const handleAddToExternalCart = () => {
    validateRequiredOptions();

    // If jewelry has configurable options, validate that all required fields are filled
    if (
      itemDetail.custom_design_configuration &&
      checkAllFieldsEntered(
        jcSelectedOption?.current?.option_value,
        jcSelectedOption?.current?.option_required
      )
    ) {
      showToast(
        t("productDetailPage.addToCart.error.title.text"),
        t(
          "productDetailPage.addToExternalCart.configError.text",
          "Please select/add all required details to add items to the cart."
        ),
        ToastTypes.ERROR,
        true,
        true
      );
      return;
    }

    const quantity = getMaxExternalCartQuantity(product_type, itemQuantity);

    const success = sendToParentCart(
      itemDetail,
      product_type,
      quantity,
      jcSelectedOption?.current?.option_value,
      personalization
    );

    if (success) {
      showToast(
        "",
        t(
          "productDetailPage.addToExternalCart.success.text",
          "Item added to cart successfully."
        ),
        ToastTypes.SUCCESS,
        true,
        true,
        80
      );
    } else {
      showToast(
        "",
        t(
          "productDetailPage.addToExternalCart.failure.text",
          "Failed to add item to cart. Please try again."
        ),
        ToastTypes.ERROR,
        true,
        true,
        80
      );
    }
  };

  const addToBulkRequest = (cartType: CartTypeEnum, productType: string) => {
    let stockItemsCart: CartTypeRequest = {
      stock_item_id: itemDetail.id,
      cart_type: cartType,
      stock_type: getStockItemType(productType as ProductCategory),
      price_mode: priceMode,
      ...((isPair(itemDetail) || (isCustomApp && isParcel(itemDetail))) && {
        product_sub_type: consolidatedStoneType.enabled
          ? "all"
          : isPair(itemDetail)
          ? StoneType.PAIR
          : StoneType.PARCELS,
      }),
      ...(allowQuantityOnBulk &&
        productType === ProductCategory.JEWELRY &&
        !enterSecondFlow && {
          quantity: itemQuantity,
        }),
      additional_attributes: {
        config: jcSelectedOption.current.option_value,
        personalization: personalization ?? {},
      },
    };

    addToCart.mutate(
      {
        stock_items_cart: stockItemsCart,
      },
      {
        onSuccess(data, variables) {
          if (data?.data?.response?.error_code === 0) {
            showToast(
              "",
              t(
                data?.data?.response?.translation_key ??
                  data?.data?.response?.message
              ),
              ToastTypes.SUCCESS,
              true,
              true,
              80
            );
            if (variables?.stock_items_cart?.stock_item_id) {
              setItemDetail({ ...itemDetail, in_cart: true });
            }
          } else if (data?.data?.response?.error_code > 0) {
            if (data?.data?.response?.error_code === 1) {
              showToast(
                "",
                t(
                  "global.addToBulkRequest.itemAlreadyInBulkRequest.text",
                  t(
                    data?.data?.response?.translation_key ??
                      data?.data?.response?.error_message
                  )
                ),
                ToastTypes.INFO,
                true,
                true,
                80
              );
            } else {
              showToast(
                "",
                t(
                  data?.data?.response?.translation_key ??
                    data?.data?.response?.error_message
                ),
                ToastTypes.INFO,
                true,
                true,
                80
              );
            }
          }
        },
      }
    );
  };

  const checkItemAvailabilityForBulk = (
    cartType: CartTypeEnum,
    productType: string,
    isBuyNow: boolean = false
  ) => {
    checkItemAvailability.mutate(
      { stock_item_ids: [itemDetail.id] },
      {
        onSuccess(data) {
          let response: CheckItemAvailabilityResponse = data?.data;
          if (response?.status_code === 1) {
            if (cartType === CartTypeEnum.BULK_REQUEST_TYPE) {
              addToBulkRequest(cartType, productType);
            } else {
              addToOrderCart(cartType, productType, isBuyNow);
            }
          } else if (response?.status_code === 0) {
            showToast(
              "",
              t("productDetail.addToCart.unavailable.text"),
              ToastTypes.ERROR,
              true,
              true
            );
          }
        },
      }
    );
  };

  const navigateToOrderCartScreen = (response: CartItemsResult) => {
    navigate(Routes.BulkRequestNavigator, {
      screen: Routes.OrderCartScreen,
      params: {
        isBuyNow: true,
        buyNowSessionId: response?.response.buy_now_session_id,
        productSubType: response?.response.product_sub_type,
      },
    });
  };

  const addToOrderCart = (
    cartType: CartTypeEnum,
    productType: string,
    isBuyNow: boolean = false
  ) => {
    const shouldSendAttributes =
      (enterSecondFlow && fromReviewPage) ||
      [ProductCategory.JEWELRY, ProductCategory.LABGROWN_JEWELRY].includes(
        productType as ProductCategory
      );

    const stockItemsCart: CartTypeRequest = {
      stock_item_id: itemDetail.id,
      cart_type: cartType,
      stock_type: getStockItemType(productType as ProductCategory),
      ...(isBuyNow && {
        buy_now: isBuyNow,
      }),
      price_mode: priceMode,
      ...((isPair(itemDetail) || (isCustomApp && isParcel(itemDetail))) && {
        product_sub_type: consolidatedStoneType?.enabled
          ? "all"
          : isPair(itemDetail)
          ? StoneType.PAIR
          : StoneType.PARCELS,
      }),
      ...(!enterSecondFlow && { quantity: itemQuantity }),
      additional_attributes: {
        ...(shouldSendAttributes && {
          config: jcSelectedOption.current.option_value ?? {},
          personalization: personalization ?? {},
        }),
        ...(enterSecondFlow &&
          fromReviewPage && {
            request_type: PdpSections.JEWELRY_BUILDER,
            selected_jewelry_id: itemDetail.id,
            selected_stock_item_ids: [
              stoneItemDetail.id,
              ...(Object.keys(matchingPairItemDetail || {}).length > 0
                ? [matchingPairItemDetail.id]
                : []),
            ],
            selected_stock_type: getStockItemType(stoneItemDetail.type),
          }),
      },
    };

    addToCart.mutate(
      {
        stock_items_cart: stockItemsCart,
      },
      {
        onSuccess(data, variables) {
          if (data?.data?.response?.error_code === 0) {
            if (fromReviewPage && !isBuyNow) {
              toggleModal("showAddToCartSuccessPopUp", true);
            } else {
              if (!isBuyNow) {
                showToast(
                  "",
                  t(
                    "productDetail.addToCart.success.text",
                    t(
                      data?.data?.response?.translation_key ??
                        data?.data?.response?.message
                    )
                  ),
                  ToastTypes.SUCCESS,
                  true,
                  true,
                  80
                );
              }
            }
            if (variables?.stock_items_cart?.stock_item_id) {
              // setItemDetail({ ...itemDetail, in_cart: true });  // TBD: Commented for now as max_quantity is not added by the backend yet
            }
            if (isBuyNow) {
              if (fromReviewPage || (enableJewelryBuilder && enterSecondFlow)) {
                const popNavigation = () => {
                  return new Promise<void>((resolve, reject) => {
                    try {
                      toggleModal("showAddToCartSuccessPopUp", false);
                      resolve();
                    } catch (error) {
                      console.error("Error while navigating back:", error);
                      reject(error);
                    }
                  });
                };

                popNavigation()
                  .then(() => {
                    dispatch(resetFiltersPayload());
                    if (history.length > 0) {
                      (navigation as any).pop(history.length);
                    }
                    clearRouteHistory();
                    resetDefaultSlug(true);
                    setItemDetail({});
                    setStoneItemDetail({});
                    setMatchingPairItemDetail({});
                    if (Platform.OS === "web") {
                      localStorage.removeItem("stoneItemDetails");
                      localStorage.removeItem("itemDetails");
                    }
                    navigateToOrderCartScreen(data?.data);
                  })
                  .catch((error) => {
                    console.error("Failed to complete navigation:", error);
                  });
              } else {
                navigateToOrderCartScreen(data?.data);
              }
            }
            queryClient
              .invalidateQueries({ queryKey: ["GET_CART_ITEM"] })
              .then();
          } else if (data?.data?.response?.error_code > 0) {
            if (data?.data?.response?.error_code === 13) {
              showToast(
                "",
                t(
                  "productDetail.addToCart.maxQuantity.text",
                  "Entered quantity is out of availability"
                ),
                ToastTypes.INFO,
                true,
                true,
                80
              );
            } else {
              showToast(
                "",
                t(
                  data?.data?.response?.translation_key ??
                    data?.data?.response?.error_message
                ),
                ToastTypes.INFO,
                true,
                true,
                80
              );
            }
          }
        },
      }
    );
  };

  const handleChooseStone = (product: string) => {
    if (stoneToSettingPopupDismissed) {
      const isValid =
        (product_type === ProductCategory.JEWELRY ||
          product_type === ProductCategory.LABGROWN_JEWELRY) &&
        !checkAllFieldsEntered(
          jcSelectedOption?.current?.option_value,
          jcSelectedOption?.current?.option_required
        );

      validateRequiredOptions();

      if (isValid) {
        jumpInSettingToStoneFlow(product);
      } else {
        showSelectSettingError();
        return;
      }
      return;
    }
    switch (product) {
      case ProductCategory.DIAMOND:
      case ProductCategory.GEMSTONE:
      case ProductCategory.LAB_GROWN_DIAMOND:
        const name =
          theme.isLargeScreen || theme.isTablet
            ? Routes.FilterSplitScreen
            : Routes.SearchResultScreen;
        const params = {
          priceMode,
          productType: product,
          fromNewFilterScreen: false,
          filterSplitStep: 2,
          sectionName: SearchFilterTypeEnum.SINGLE_STONES,
          productPrefix: getProductPrefix(product),
          breadCrumbLabel: "Stone Search",
          enterSecondFlow: true,
          saved_search: JSON.stringify({
            shapes: [jcSelectedOption.current?.option_value?.supported_shapes],
            size_from:
              jcSelectedOption.current?.option_value?.supported_carat_from,
            size_to: jcSelectedOption.current?.option_value?.supported_carat_to,
            itemType: 1,
            sub_type: null,
            preference: [],
            vdb_setting: "true",
            stock_item_ids: [route?.params?.productID as number],
          }),
        };
        dispatch(resetMinMaxOptions());
        setEnabled(true);
        dispatch(setBuilderProduct(product));
        dispatch(setProductType(product));
        dispatch(setSectionName(getSectionName(product)));
        const mRoute = { name, params };
        addRouteToHistory(mRoute);
        setStoneItemDetail(itemDetail);
        queryClient.resetQueries({ queryKey: ["PRODUCT_PAGE"] });
        push(name, params);
        break;
    }
  };

  const handleAddToJewelryOptionSelection = (optionName: string) => {
    switch (optionName) {
      case AddJewelryOptions.ENGAGEMENT_RING:
      case AddJewelryOptions.PENDANT:
        const name =
          theme.isLargeScreen || theme.isTablet
            ? Routes.FilterSplitScreen
            : Routes.SearchResultScreen;
        const params = {
          priceMode,
          productType: ProductCategory.JEWELRY,
          fromNewFilterScreen: false,
          filterSplitStep: 2,
          sectionName: SearchFilterTypeEnum.JEWELRY,
          productPrefix: ProductCategory.JEWELRY,
          breadCrumbLabel: "Setting Search",
          enterSecondFlow: true,
          saved_search: JSON.stringify({
            jewelry_styles: [optionName],
            itemType: 2,
            sub_type: null,
            preference: [],
            vdb_setting: "true",
            stock_item_ids: [route?.params?.productID as number],
            is_center_size_selected: "true",
          }),
          searchForRing: optionName === AddJewelryOptions.ENGAGEMENT_RING,
          searchForPendant: optionName === AddJewelryOptions.PENDANT,
        };
        dispatch(setDisableJewelrySettingStoneLinkage(false));
        dispatch(setBuilderProduct(ProductCategory.JEWELRY));
        const mRoute = { name, params };
        addRouteToHistory(mRoute);
        setStoneItemDetail(itemDetail);
        queryClient.resetQueries({ queryKey: ["PRODUCT_PAGE"] });
        push(name, params);
        break;

      case AddJewelryOptions.EARRINGS:
        if (!haveMatchPair) {
          showToast(
            "",
            t("productDetailPage.findMatch.error.title.text"),
            ToastTypes.ERROR,
            true,
            true
          );
          return;
        }
        const mName = Routes.FindMatchScreen;
        const mParams = {
          itemId: itemDetail?.id as number,
          priceMode,
          productPrefix: product_type,
          productType: product_type,
          breadCrumbLabel: BreadCrumbLabel.MATCHING_STONE,
          showPairButton: true,
        };
        dispatch(setBuilderProduct(product_type));
        const xRoute = { name: mName, params: mParams };
        addRouteToHistory(xRoute);
        push(mName, mParams);
        break;
    }
  };

  const openAddToJewelryOptions = () => {
    if (
      enterSecondFlow &&
      isEarring &&
      product_type !== ProductCategory.JEWELRY
    ) {
      if (!haveMatchPair) {
        showToast(
          "",
          t("productDetailPage.findMatch.error.title.text"),
          ToastTypes.ERROR,
          true,
          true
        );
        return;
      }
      const name = Routes.FindMatchScreen;
      const params = {
        itemId: itemDetail?.id as number,
        priceMode,
        productPrefix: product_type,
        productType: product_type,
        breadCrumbLabel: BreadCrumbLabel.MATCHING_STONE,
        enterSecondFlow: true,
      };
      dispatch(setBuilderProduct(product_type));
      const mRoute = { name, params };
      addRouteToHistory(mRoute);
      push(name, params);
      return;
    }

    validateRequiredOptions();

    if (enterSecondFlow) {
      if (mandatoryOptionsSelected()) {
        navigateToReviewPage();
      } else {
        showSelectSettingError();
        return;
      }
      return;
    }

    const hasMultipleOptions =
      product_type === ProductCategory.JEWELRY ||
      product_type === ProductCategory.LABGROWN_JEWELRY
        ? chooseStones?.length > 1
        : getAddToJewelryOptionsData?.data?.add_to_jewelry?.options.length > 1;

    if (hasMultipleOptions) {
      if (mandatoryOptionsSelected()) {
        setAddToJewelryMenu(true);
      } else {
        showSelectSettingError();
        return;
      }
      return;
    }

    if (
      product_type === ProductCategory.JEWELRY ||
      product_type === ProductCategory.LABGROWN_JEWELRY
    ) {
      if (mandatoryOptionsSelected()) {
        handleChooseStone(
          chooseStones?.[0]?.action_name ?? chooseStones?.[0]?.name
        );
      } else {
        showSelectSettingError();
        return;
      }
    } else {
      handleAddToJewelryOptionSelection(
        getAddToJewelryOptionsData?.data?.add_to_jewelry?.options[0].name
      );
    }
  };

  const getTooltipText = (
    name: string,
    disabledMemoOption: boolean,
    segment_identifier?: string
  ) => {
    if (segment_identifier === "request_item" || !theme.isLargeScreen) {
      return "";
    }
    if (name === "memo" && disabledMemoOption) {
      return t("bmh.tooltip.text");
    }
    switch (name) {
      case "memo":
        return t("bmh.tooltip.memo.text");
      case "hold":
        return t("bmh.tooltip.hold.text");
      case "buy":
        return t("bmh.tooltip.buy.text");
      default:
        return "";
    }
  };

  const jumpInSettingToStoneFlow = (product?: string) => {
    const searchScreenRoute = theme.isMobile
      ? Routes.SearchResultScreen
      : Routes.FilterSplitScreen;

    const mStoneProductType = product ?? history[0]?.params?.productType;

    const filtered = history.filter(
      (item) =>
        [searchScreenRoute, Routes.PDPScreen, Routes.FindMatchScreen].includes(
          item.screen
        ) && item.params.productType === "jewelry"
    );

    const stoneFilterSplitScreen = history.filter(
      (item) =>
        [searchScreenRoute].includes(item.screen) &&
        item.params.productType !== "jewelry"
    );

    const stoneRouteParams = {
      ...stoneFilterSplitScreen?.[0]?.params,
      filterSplitStep: 2,
      ...(product && {
        productType: product,
        productPrefix: getProductPrefix(product),
        sectionName: getSectionName(product),
      }),
    };

    stoneRouteParams.enterSecondFlow = true;
    const saved_search = {
      shapes: [jcSelectedOption.current?.option_value?.supported_shapes],
      size_from: jcSelectedOption.current?.option_value?.supported_carat_from,
      size_to: jcSelectedOption.current?.option_value?.supported_carat_to,
      itemType: 1,
      sub_type: null,
      preference: [],
      vdb_setting: "true",
      stock_item_ids: [mStoneItemDetail?.id],
    };
    stoneRouteParams.saved_search = JSON.stringify(saved_search);

    const stoneRoute = {
      name: searchScreenRoute,
      params: stoneRouteParams,
    };

    const sectionName = filtered?.[0]?.params?.sectionName;
    const productType = filtered?.[0]?.params?.productType;

    const cleanedPayload = {
      ...auxPayload,
      [sectionName]: Object.fromEntries(
        Object.entries(auxPayload[sectionName]).filter(
          ([key]) =>
            ![
              "jewelry_styles",
              "searchForPendant",
              "searchForRing",
              "stock_item_ids",
            ].includes(key)
        )
      ),
    };

    const payload = cleanedPayload[sectionName];

    if (Object.keys(payload).length > 0) {
      dispatch(
        setFiltersPayload({
          sectionName: sectionName,
          data: payload,
        })
      );

      dispatch(
        setPayloadData({
          productType: productType,
          data: { [sectionName]: payload },
        })
      );
    }

    dispatch(setAuxPayloadData(cleanedPayload));

    clearRouteHistory();
    dispatch(setBuilderProduct(mStoneProductType));
    if (product) {
      dispatch(setProductType(product));
      dispatch(setSectionName(getSectionName(product)));
    }

    const routes = filtered.map((_item) => {
      const { screen, params } = _item;

      let newParams =
        screen === searchScreenRoute
          ? toSettingSearchFirstFlowParams(params)
          : { ...params, enterSecondFlow: false };

      if (screen === Routes.PDPScreen) {
        newParams.productID = mItemDetail?.id;
      }

      return {
        name: screen,
        params: newParams,
      };
    });

    // add explore screen for mobile
    const exploreScreenRoute = {
      name: Routes.Explore,
      params: {},
    };

    // add filter screen for mobile
    const filterScreenRoute = {
      name: Routes.FilterScreen,
      params: {
        productType: productType,
        productPrefix: getProductPrefix(productType),
        sectionName: sectionName,
        fromResultScreen: false,
      },
    };

    const mobileRoutes = [exploreScreenRoute, filterScreenRoute];

    routes.push(stoneRoute);
    let finalRoutes =
      theme.isMobile || theme.isTablet ? [...mobileRoutes, ...routes] : routes;

    // reset item detail objects
    setStoneItemDetail(mItemDetail);
    clearItemDetail(false);

    navigation.dispatch(
      CommonActions.reset({
        index: finalRoutes.length - 1,
        routes: finalRoutes,
      })
    );

    filtered.forEach((_item) => {
      const screenRoute = _item.screen;
      const params = {
        ...(screenRoute === searchScreenRoute
          ? toSettingSearchFirstFlowParams(_item.params)
          : {
              ..._item.params,
              enterSecondFlow: _item?.params?.productType !== "jewelry",
            }),
        ...(screenRoute === Routes.FindMatchScreen && { showPairButton: true }),
        ...(screenRoute === Routes.PDPScreen && {
          productID: mItemDetail?.id,
        }),
      };

      const mRoute = {
        name: screenRoute,
        params,
      };

      addRouteToHistory(mRoute);
    });
    // After all routes added, push the stone route
    addRouteToHistory(stoneRoute);
  };

  const handleBottomButtonActions = (action_name: string) => {
    if (
      !userInfo.isIFrame() &&
      isGuest &&
      action_name !== "ask_supplier" &&
      action_name !== "jewelry_builder_button"
    ) {
      dispatch(setLoginModalType("default"));
      return;
    }
    const buttonConfig = bottomButtons
      .flat()
      .find((btn) => btn.name === action_name);

    if (
      (theme.isMobile || theme.isTablet) &&
      buttonConfig?.name === "request_options" &&
      buttonConfig?.segment_identifier === "request_options" &&
      buttonConfig?.options &&
      Object.keys(buttonConfig.options).length > 0
    ) {
      toggleModal("showButtonsOptions", true);
      return;
    }

    switch (action_name) {
      case "ask_supplier":
        handleOpenAskSupplier();
        break;

      case "request_item":
        if ((fromRequest || fromOrderCart) && enableJewelryBuilder) {
          showAddToJewelryError("request");
        } else {
          if (userInfo?.canRequest()) {
            handleOpen("memo");
          } else {
            toggleModal("bmhPopUp", true);
          }
        }
        break;

      case "buy":
        if ((fromRequest || fromOrderCart) && enableJewelryBuilder) {
          showAddToJewelryError("request");
        } else {
          if (userInfo?.canRequest()) {
            handleOpen("buy");
          } else {
            toggleModal("bmhPopUp", true);
          }
        }
        break;

      case "memo":
        if ((fromRequest || fromOrderCart) && enableJewelryBuilder) {
          showAddToJewelryError("request");
        } else {
          !userInfo.isIFrame()
            ? userInfo?.canRequest()
              ? handleOpen("memo")
              : toggleModal("bmhPopUp", true)
            : toggleModal("iFramePopUp", true);
        }
        break;

      case "hold":
        if ((fromRequest || fromOrderCart) && enableJewelryBuilder) {
          showAddToJewelryError("request");
        } else {
          if (userInfo?.canRequest()) {
            handleOpen("hold");
          } else {
            toggleModal("bmhPopUp", true);
          }
        }
        break;

      case "add_to_bulk":
        if ((fromRequest || fromOrderCart) && enableJewelryBuilder) {
          showAddToJewelryError("order");
        } else {
          handleAddToBulkRequest();
        }
        break;

      case "add_to_cart":
        if (Number(itemDetail?.total_sales_price) === 0) {
          showToast(
            undefined,
            t(
              "productDetailPage.addToCart.noMatch.error.title.text",
              "No price matching the selected configuration."
            ),
            ToastTypes.ERROR,
            true,
            true
          );
          return;
        }
        if ((fromRequest || fromOrderCart) && enableJewelryBuilder) {
          showAddToJewelryError("order");
        } else if (userInfo.enableThirdPartyAddToCart()) {
          handleAddToExternalCart();
        } else {
          handleAddToCart();
        }
        break;

      case "jewelry_builder_button":
        if (stoneToSettingPopupDismissed) {
          if (chooseStones?.length > 1) {
            setAddToJewelryMenu(true);
          } else {
            handleChooseStone(chooseStones?.[0]?.action_name);
          }
        } else if ((fromRequest || fromOrderCart) && enableJewelryBuilder) {
          showAddToJewelryError("builder");
        } else {
          openAddToJewelryOptions();
        }
        break;
      case "see_buy_request":
      case "see_order_cart":
        handleSeeBuyRequest();
        break;
      case "added_to_cart":
        showAddedToCartError();
        break;
      case "buy_now":
        if ((fromRequest || fromOrderCart) && enableJewelryBuilder) {
          showAddToJewelryError("order");
        } else {
          handleBuyNow(true);
        }
        break;
      case "external_link":
        const requestOptionsConfig = bottomButtons
          .flat()
          .find((btn) => btn.name === "request_options");

        const redirectionUrl =
          buttonConfig?.redirection_url ||
          (theme.isMobile || theme.isTablet
            ? requestOptionsConfig?.options?.external_link?.redirection_url
            : undefined);

        if (redirectionUrl) {
          Linking.canOpenURL(redirectionUrl).then((supported) => {
            if (supported) {
              Linking.openURL(redirectionUrl);
            }
          });
        }
        break;
      default:
        if ((fromRequest || fromOrderCart) && enableJewelryBuilder) {
          showAddToJewelryError("request");
        } else {
          handleOpen("memo");
        }
        break;
    }
  };

  const jewelryBuilderButtonTitle =
    product_type !== ProductCategory.JEWELRY
      ? !enterSecondFlow
        ? getAddToJewelryOptionsData?.data?.add_to_jewelry.options.length === 1
          ? getAddToJewelryOptionsData?.data?.add_to_jewelry.options[0]
              .long_name
          : getAddToJewelryOptionsData?.data?.add_to_jewelry?.title
        : isEarring
        ? t("productDetailPage.choosePairDiamond.title.text")
        : isPendant
        ? t("productDetailPage.addToPendant.title.text")
        : t("productDetailPage.addToRing.title.text")
      : !enterSecondFlow
      ? chooseStones?.length > 1
        ? t(
            theme.isMobile
              ? "productDetailPage.more.title.text"
              : "productDetailPage.chooseStone.title.text"
          )
        : t(`${chooseStones?.[0]?.label || ""}`)
      : stoneToSettingPopupDismissed
      ? t("productDetailPage.chooseStone.title.text", "Choose Stone")
      : t("productDetailPage.selectSetting.title.text");

  // Keep the rendered output fresh on every render (latest closures), but
  // expose a stable `BottomButtonView` function identity below so React does
  // NOT remount the Button subtree when an input's onBlur triggers a state
  // change mid-tap. Without this, the first tap on a bottom button only blurs
  // the focused Personalization input; a second tap is needed to fire onPress.
  const renderBottomButtonRef = useRef<(props: { bottomButton: any }) => any>(
    () => null
  );
  renderBottomButtonRef.current = ({ bottomButton }: any) => {
    const toTestId = (value: string) =>
      value.replace(/\s+/g, "-").toLowerCase();
    const buttonKey = toTestId(String(bottomButton?.name ?? "unknown"));
    const canProceed = isJewelry
      ? !isCustomizableJewelry
      : bottomButton.status === "enabled" ||
        (!enterSecondFlow &&
          getAddToJewelryOptionsData?.data?.add_to_jewelry?.options.length ===
            0);
    if (
      bottomButton.name === "request_item" &&
      !userInfo.companyIdentifierEnabled() &&
      itemDetail?.company_identifier
    ) {
      return null;
    } else if (itemDetail?.company_identifier) {
      if (
        !userInfo.companyIdentifierEnabled() &&
        bottomButton.name !== "ask_supplier"
      ) {
        return null;
      }
    }

    return (
      <ButtonFlexContainer
        applyPaddingTop={fromReviewPage ? !theme.isMobile : true}
        minWidth={bottomButton?.minWidth}
      >
        <TooltipButton
          tooltip={getTooltipText(bottomButton.name, disabledMemo)}
          children={
            bottomButton.name === "jewelry_builder_button" ? (
              theme.isLargeScreen ? (
                <StyledMenu
                  mt={Platform.OS === "ios" ? 0 : -30}
                  py={0}
                  useRNModal
                  borderRadius={8}
                  marginLeft={!theme.isMobile ? 0 : 10}
                  placement={"top"}
                  backgroundColor={theme["core-01"]}
                  isOpen={addToJewelryMenu}
                  onClose={() => {
                    setAddToJewelryMenu(false);
                  }}
                  selectionMode="single"
                  position="absolute"
                  bottom={SpaceType.Big}
                  left={-120}
                  trigger={({ ...triggerProps }) => {
                    return (
                      <TouchableOpacity
                        {...triggerProps}
                        disabled={canProceed}
                        testID={`pdp.bottom.menu.trigger.${buttonKey}`}
                        data-testId={`pdp.bottom.menu.trigger.${buttonKey}`}
                      >
                        <Button
                          testID={`pdp.bottom.button.${buttonKey}`}
                          dataTestId={`pdp.bottom.button.${buttonKey}`}
                          showIcon={bottomButton?.icon?.data}
                          iconSource={bottomButton?.icon?.data}
                          iconColor={theme["core-01"]}
                          iconSize={SpaceType.Big}
                          showLeftText={true}
                          hideText={true}
                          type={bottomButton?.type ?? ButtonType.primary}
                          category={getButtonCategory(product_type)}
                          title={jewelryBuilderButtonTitle}
                          width={"100%"}
                          onPress={() =>
                            handleBottomButtonActions(bottomButton.name)
                          }
                          disabled={canProceed}
                        />
                      </TouchableOpacity>
                    );
                  }}
                >
                  {!enterSecondFlow && product_type !== ProductCategory.JEWELRY
                    ? getAddToJewelryOptionsData &&
                      getAddToJewelryOptionsData?.data?.add_to_jewelry?.options.map(
                        (option, index) => {
                          return (
                            <MenuItem
                              testID={`pdp.bottom.menu.option.${toTestId(
                                String(option.name)
                              )}`}
                              data-testId={`pdp.bottom.menu.option.${toTestId(
                                String(option.name)
                              )}`}
                              key={option.name}
                              textValue={option.short_name}
                              style={{
                                padding: 0,
                                backgroundColor: theme.transparent,
                              }}
                              onPress={() =>
                                handleAddToJewelryOptionSelection(option.name)
                              }
                            >
                              <MenuItemContainer>
                                <MenuItemStyle
                                  optionSize={
                                    getAddToJewelryOptionsData?.data
                                      ?.add_to_jewelry?.options?.length
                                  }
                                  index={index}
                                >
                                  <VDBText
                                    color={theme["core-05"]}
                                    type={typography["Minor-M"]}
                                  >
                                    {t(option.long_name)}
                                  </VDBText>
                                </MenuItemStyle>
                                {index <
                                  getAddToJewelryOptionsData?.data
                                    ?.add_to_jewelry?.options?.length -
                                    1 && (
                                  <LineViewContainer background={"core-03"} />
                                )}
                              </MenuItemContainer>
                            </MenuItem>
                          );
                        }
                      )
                    : (!enterSecondFlow || stoneToSettingPopupDismissed) &&
                      chooseStones?.map((option, index) => {
                        return (
                          <MenuItem
                            testID={`pdp.bottom.menu.option.${toTestId(
                              String(option.action_name ?? option.name)
                            )}`}
                            data-testId={`pdp.bottom.menu.option.${toTestId(
                              String(option.action_name ?? option.name)
                            )}`}
                            key={option.name}
                            textValue={option.label}
                            style={{
                              padding: 0,
                              backgroundColor: theme.transparent,
                            }}
                            onPress={() =>
                              handleChooseStone(option.action_name)
                            }
                          >
                            <MenuItemContainer>
                              <MenuItemStyle
                                optionSize={chooseStones?.length}
                                index={index}
                              >
                                <VDBText
                                  color={theme["core-05"]}
                                  type={typography["Minor-M"]}
                                >
                                  {t(option.label)}
                                </VDBText>
                              </MenuItemStyle>
                              {index < chooseStones?.length - 1 && (
                                <LineViewContainer background={"core-03"} />
                              )}
                            </MenuItemContainer>
                          </MenuItem>
                        );
                      })}
                </StyledMenu>
              ) : (
                <Button
                  testID={`pdp.bottom.button.${buttonKey}`}
                  dataTestId={`pdp.bottom.button.${buttonKey}`}
                  showIcon={bottomButton?.icon?.data}
                  iconSource={bottomButton?.icon?.data}
                  iconColor={theme["core-01"]}
                  iconSize={SpaceType.Big}
                  showLeftText={true}
                  hideText={true}
                  type={bottomButton?.type ?? ButtonType.primary}
                  category={getButtonCategory(product_type)}
                  title={jewelryBuilderButtonTitle}
                  width={"100%"}
                  onPress={() => handleBottomButtonActions(bottomButton.name)}
                  disabled={canProceed}
                />
              )
            ) : (
              <Button
                testID={`pdp.bottom.button.${buttonKey}`}
                dataTestId={`pdp.bottom.button.${buttonKey}`}
                showIcon={bottomButton?.icon?.data}
                iconSource={bottomButton?.icon?.data}
                iconColor={theme["core-01"]}
                iconSize={SpaceType.Big}
                showLeftText={true}
                hideText={true}
                type={bottomButton?.type ?? ButtonType.primary}
                category={getButtonCategory(product_type)}
                title={
                  itemDetail?.company_identifier &&
                  userInfo.companyIdentifierEnabled() &&
                  bottomButton?.name === "request_item"
                    ? t(
                        "productDetailPage.soldReturn.button.text",
                        "Sold/Return"
                      )
                    : t(bottomButton?.label)
                }
                width={"100%"}
                onPress={() => handleBottomButtonActions(bottomButton.name)}
                disabled={
                  (bottomButton.name === "memo" &&
                  bottomButton?.segment_identifier === "request_item" &&
                  disabledMemo
                    ? true
                    : false) ||
                  bottomButton?.disabled ||
                  (bottomButton.name === "add_to_cart" &&
                    Number(itemDetail?.total_sales_price) === 0) ||
                  (allowBMHAndCartActions &&
                    itemDetail?.allow_bmh_and_cart_actions === false &&
                    bottomButton.name !== "ask_supplier")
                }
              />
            )
          }
          enableTooltip={
            getTooltipText(
              bottomButton.name,
              disabledMemo,
              bottomButton?.segment_identifier
            ) === ""
              ? false
              : true
          }
        />
        {bottomButton.name === "jewelry_builder_button" &&
          addToJewelryMenu &&
          !theme.isLargeScreen && (
            <OptionsModal
              {...(!theme.isLargeScreen && {
                isOpen: addToJewelryMenu,
                onClose: () => {
                  setAddToJewelryMenu(false);
                },
              })}
              options={
                product_type !== ProductCategory.JEWELRY
                  ? getAddToJewelryOptionsDataOptions(
                      getAddToJewelryOptionsData?.data?.add_to_jewelry?.options,
                      getAddToJewelryOptionsData
                    )
                  : getChooseStoneOptions(chooseStones)
              }
              onOptionSelect={(optionName) => {
                if (product_type !== ProductCategory.JEWELRY) {
                  handleAddToJewelryOptionSelection(optionName);
                } else {
                  const stone = chooseStones?.find(
                    (s) => s.name === optionName
                  );
                  handleChooseStone(stone?.action_name ?? optionName);
                }
                setAddToJewelryMenu(false);
              }}
              t={t}
              priceMode={priceMode}
              title={
                product_type === ProductCategory.JEWELRY ||
                product_type === ProductCategory.LABGROWN_JEWELRY
                  ? t("productDetailPage.chooseStone.popup.title.text")
                  : jewelryBuilderButtonTitle
              }
            />
          )}
      </ButtonFlexContainer>
    );
  };

  // Stable identity (empty deps) — `<BottomButtonView />` therefore never
  // changes component type across renders, preserving the Button's Pressable
  // instance even when context state (e.g. personalization) updates mid-tap.
  // Latest closures are reached via `renderBottomButtonRef.current`, which is
  // reassigned above on every render.
  const BottomButtonView = useCallback(
    (props: { bottomButton: any }) => renderBottomButtonRef.current(props),
    []
  );

  return {
    BottomButtonView,
    handleBottomButtonActions,
    getTooltipText,
    openAddToJewelryOptions,
    handleAddToJewelryOptionSelection,
    addToOrderCart,
    addToBulkRequest,
    handleAddToCart,
    handleAddToExternalCart,
    handleAddToBulkRequest,
    handleOpenAskSupplier,
    handleOpen,
    toggleModal,
    handleAddToShopifyCart,
    isShopifyCartLoading: createShopifyProduct.isPending || isShopifyDelaying,
  };
};

export default PdpBottomButtons;

const StyledMenu = styled(Menu)`
  box-shadow: ${({ theme }) => getBoxShadow(theme.Shadows.Huge)};
`;

const ButtonFlexContainer = styled.View<{
  minWidth?: string;
  applyPaddingTop?: boolean;
}>`
  display: ${({ theme }) => (!theme.isMobile ? "block" : "flex")};
  ${({ theme }) =>
    !theme.isMobile &&
    css`
      min-width: 144px;
    `}
  padding-bottom: ${({ theme }) => (theme.isMobile ? 0 : SpaceType.Double)}px;
  padding-top: ${({ theme, applyPaddingTop }) =>
    applyPaddingTop
      ? theme.isMobile
        ? SpaceType.Basic
        : SpaceType.Double
      : 8}px;
  ${({ theme }) =>
    theme.isMobile &&
    css`
      flex: 1;
      max-width: 100%;
    `}
`;

const MenuItemContainer = styled.View``;

const MenuItemStyle = styled.View<any>`
  border-color: #000000;
  width: 250px;
  padding: 10px;
  border-top-left-radius: ${({ optionSize, index }) =>
    optionSize === 1 || index === 0 ? 8 : 0}px;
  border-top-right-radius: ${({ optionSize, index }) =>
    optionSize === 1 || index === 0 ? 8 : 0}px;
  border-bottom-left-radius: ${({ optionSize, index }) =>
    index === optionSize - 1 ? 8 : 0}px;
  border-bottom-right-radius: ${({ optionSize, index }) =>
    index === optionSize - 1 ? 8 : 0}px;
`;
